import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=4f510e2c&scoped=true"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"
import style0 from "./Box.vue?vue&type=style&index=0&id=4f510e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f510e2c",
  null
  
)

export default component.exports